<template>
  <form>
    <VxLabelTooltip
      label="対象ポートフォリオ"
      text="入札ルールを適応するポートフォリオを選択します。ポートフォリオに属しないキャンペーンに入札ルールを適応することはできません。"
      position="bottom"
      min-width="250px"
      z-index="53001"
    />
    <SelectField
      v-model="innerPortfolios"
      name="対象ポートフォリオ"
      label=""
      rules="required"
      :options="optionPortfolios"
      :max-result-shown="maxResultShown"
      :searchable="false"
      multiple
      full-width
      return-object
    />
    <SelectField
      v-model="innerFrequency"
      name="ルール実行頻度"
      label="ルール実行頻度"
      class="mt-4"
      rules="required"
      :options="optionFrequencies"
      :max-result-shown="maxResultShown"
      :searchable="false"
      multiple
      full-width
    />
    <p
      class="mt-5 pl-1"
    >
      日予算の合計金額
    </p>
    <HorizontalFieldLayout
      label="残日数"
      class="place-items-start pl-1"
      label-field-ratio="1/5"
    >
      <div class="remaining-days-layout grid gap-6 mb-5">
        <div class="flex items-center">
          <p class="mr-5">5日以内</p>
        </div>
        <div class="flex items-center">
          <div class="mt-1">残予算　×　</div>
          <InputField
            v-model="innerDays5"
            rules="required|integer|min_value:80|max_value:200"
            name="5日以内の掛け率"
            class="mr-5"
          />
          <div class="mt-1">％</div>
        </div>
      </div>
      <div class="remaining-days-layout grid gap-6 mb-5">
        <div class="flex items-center">
          <p class="mr-5">10日以内</p>
        </div>
        <div class="flex items-center">
          <div class="mt-1">残予算　×　</div>
          <InputField
            v-model="innerDays10"
            rules="required|integer|min_value:80|max_value:200"
            name="10日以内の掛け率"
            class="mr-5"
          />
          <div class="mt-1">％</div>
        </div>
      </div>
      <div class="remaining-days-layout grid gap-6 mb-5">
        <div class="flex items-center">
          <p class="mr-5">20日以内</p>
        </div>
        <div class="flex items-center">
          <div class="mt-1">残予算　×　</div>
          <InputField
            v-model="innerDays20"
            rules="required|integer|min_value:80|max_value:200"
            name="20日以内の掛け率"
            class="mr-5"
          />
          <div class="mt-1">％</div>
        </div>
      </div>
      <div class="remaining-days-layout grid gap-6 mb-5">
        <div class="flex items-center">
          <p class="mr-5">31日以内</p>
        </div>
        <div class="flex items-center">
          <div class="mt-1">残予算　×　</div>
          <InputField
            v-model="innerDays31"
            rules="required|integer|min_value:80|max_value:200"
            name="31日以内の掛け率"
            class="mr-5"
          />
          <div class="mt-1">％</div>
        </div>
      </div>
    </HorizontalFieldLayout>
    <p class="mt-5 pl-1">曜日別強化</p>
    <HorizontalFieldLayout label="曜日" class="place-items-start pl-1" label-field-ratio="1/5">
      <div class="grid gap-6 mb-5 grid-cols-2">
        <div class="flex items-center">
          <div class="mr-5">月曜日</div>
          <InputField
            v-model="innerMonday"
            rules="required|integer|min_value:100|max_value:300"
            name="月曜日の掛け率"
            class="w-24 ml-5 mr-5"
          />
          <div class="mt-1">％</div>
        </div>
        <div class="flex items-center">
          <p class="mr-5">金曜日</p>
          <InputField
            v-model="innerFriday"
            rules="required|integer|min_value:100|max_value:300"
            name="金曜日の掛け率"
            class="w-24 ml-5 mr-5"
          />
          <div class="mt-1">％</div>
        </div>
      </div>
      <div class="grid gap-6 mb-5 grid-cols-2">
        <div class="flex items-center">
          <p class="mr-5">火曜日</p>
          <InputField
            v-model="innerTuesday"
            rules="required|integer|min_value:100|max_value:300"
            name="火曜日の掛け率"
            class="w-24 ml-5 mr-5"
          />
          <div class="mt-1">％</div>
        </div>
        <div class="flex items-center">
          <p class="mr-5">土曜日</p>
          <InputField
            v-model="innerSaturday"
            rules="required|integer|min_value:100|max_value:300"
            name="土曜日の掛け率"
            class="w-24 ml-5 mr-5"
          />
          <div class="mt-1">％</div>
        </div>
      </div>
      <div class="grid gap-6 mb-5 grid-cols-2">
        <div class="flex items-center">
          <p class="mr-5">水曜日</p>
          <InputField
            v-model="innerWednesday"
            rules="required|integer|min_value:100|max_value:300"
            name="水曜日の掛け率"
            class="w-24 ml-5 mr-5"
          />
          <div class="mt-1">％</div>
        </div>
        <div class="flex items-center">
          <p class="mr-5">日曜日</p>
          <InputField
            v-model="innerSunday"
            rules="required|integer|min_value:100|max_value:300"
            name="日曜日の掛け率"
            class="w-24 ml-5 mr-5"
          />
          <div class="mt-1">％</div>
        </div>
      </div>
      <div class="grid gap-6 mb-5 grid-cols-2">
        <div class="flex items-center">
          <p class="mr-5">木曜日</p>
          <InputField
            v-model="innerThursday"
            rules="required|integer|min_value:100|max_value:300"
            name="木曜日の掛け率"
            class="w-24 ml-5 mr-5"
          />
          <div class="mt-1">％</div>
        </div>
        <div class="flex items-center"></div>
      </div>
    </HorizontalFieldLayout>
    <div class="vx-row items-end">
      <div class="vx-col w-3/5">
        <InputField
          v-model.number="innerMinBudget"
          name="最低日予算"
          label="最低日予算"
          type="number"
          rules="required|integer|min_value:100|max_value:1000"
          full-width
        />
      </div>
      <div class="vx-col w-2/5">
        <span>円</span>
      </div>
    </div>
  </form>
</template>

<script>
import { mapState } from 'vuex'
import InputField from '@/components/fields/InputField'
import SelectField from '@/components/fields/SelectField'
import VxLabelTooltip from '@/components/vx-tooltip/VxLabelTooltip'
import HorizontalFieldLayout from '@/components/layouts/form/HorizontalFieldLayout'

export default {
  name: 'AdBidBudgetForm',
  components: {
    InputField,
    SelectField,
    VxLabelTooltip,
    HorizontalFieldLayout
  },
  props: {
    id: {
      type: Number,
      default: null
    },
    portfolioIds: {
      type: Array,
      default: () => []
    },
    frequencyIds: {
      type: Array,
      default: () => [0, 1, 2, 3, 4, 5, 6]
    },
    budgetRule: {
      type: Object,
      default () {
        return {
          days5: 100,
          days10: 120,
          days20: 140,
          days31: 160,
          monday: 100,
          tuesday: 100,
          wednesday: 100,
          thursday: 100,
          friday: 100,
          saturday: 100,
          sunday: 100,
          min_budget: 1000
        }
      }
    }
  },
  emits: [
    'update:portfolio-ids',
    'update:frequency-ids',
    'update:budget-rule'
  ],
  data () {
    return {
      maxResultShown: 100
    }
  },
  computed: {
    ...mapState('adBid', ['portfolios']),
    innerPortfolios: {
      get () {
        return this.portfolioIds
      },
      set (val) {
        this.$emit('update:portfolio-ids', val)
      }
    },
    innerFrequency: {
      get () {
        return this.frequencyIds
      },
      set (val) {
        this.$emit('update:frequency-ids', val)
      }
    },
    innerDays5: {
      get () {
        return (this.budgetRule) ? this.budgetRule.days5 : null
      },
      set (val) {
        this.$emit('update:budget-rule', {...this.budgetRule, days5: ((val === '') ? null : val)})
      }
    },
    innerDays10: {
      get () {
        return (this.budgetRule) ? this.budgetRule.days10 : null
      },
      set (val) {
        this.$emit('update:budget-rule', {...this.budgetRule, days10: ((val === '') ? null : val)})
      }
    },
    innerDays20: {
      get () {
        return (this.budgetRule) ? this.budgetRule.days20 : null
      },
      set (val) {
        this.$emit('update:budget-rule', {...this.budgetRule, days20: ((val === '') ? null : val)})
      }
    },
    innerDays31: {
      get () {
        return (this.budgetRule) ? this.budgetRule.days31 : null
      },
      set (val) {
        this.$emit('update:budget-rule', {...this.budgetRule, days31: ((val === '') ? null : val)})
      }
    },
    innerMonday: {
      get() {
        return this.budgetRule ? this.budgetRule.monday : null
      },
      set(val) {
        this.$emit('update:budget-rule', {...this.budgetRule, monday: ((val === '') ? null : val)})
      }
    },
    innerTuesday: {
      get() {
        return this.budgetRule ? this.budgetRule.tuesday : null
      },
      set(val) {
        this.$emit('update:budget-rule', {...this.budgetRule, tuesday: ((val === '') ? null : val)})
      }
    },
    innerWednesday: {
      get() {
        return this.budgetRule ? this.budgetRule.wednesday : null
      },
      set(val) {
        this.$emit('update:budget-rule', {...this.budgetRule, wednesday: ((val === '') ? null : val)})
      }
    },
    innerThursday: {
      get() {
        return this.budgetRule ? this.budgetRule.thursday : null
      },
      set(val) {
        this.$emit('update:budget-rule', {...this.budgetRule, thursday: ((val === '') ? null : val)})
      }
    },
    innerFriday: {
      get() {
        return this.budgetRule ? this.budgetRule.friday : null
      },
      set(val) {
        this.$emit('update:budget-rule', {...this.budgetRule, friday: ((val === '') ? null : val)})
      }
    },
    innerSaturday: {
      get() {
        return this.budgetRule ? this.budgetRule.saturday : null
      },
      set(val) {
        this.$emit('update:budget-rule', {...this.budgetRule, saturday: ((val === '') ? null : val)})
      }
    },
    innerSunday: {
      get() {
        return this.budgetRule ? this.budgetRule.sunday : null
      },
      set(val) {
        this.$emit('update:budget-rule', {...this.budgetRule, sunday: ((val === '') ? null : val)})
      }
    },
    innerMinBudget: {
      get () {
        return (this.budgetRule) ? this.budgetRule.min_budget : null
      },
      set (val) {
        this.$emit('update:budget-rule', {...this.budgetRule, min_budget: ((val === '') ? null : val)})
      }
    },
    optionPortfolios () {
      return Object.entries(this.portfolios)
        .map(([id, { name, amount, policy, startDate, endDate, existDeliveryDownRule }]) => {
          if (policy == 'dateRange') {
            return ({text: name, value: id, $isDisabled: (!amount || !startDate || !endDate || existDeliveryDownRule == 0) })
          }
          return ({text: name, value: id, $isDisabled: (!amount || existDeliveryDownRule == 0) })
        })
    },
    optionFrequencies () {
      return [
        {text: '日曜日', value: 0},
        {text: '月曜日', value: 1},
        {text: '火曜日', value: 2},
        {text: '水曜日', value: 3},
        {text: '木曜日', value: 4},
        {text: '金曜日', value: 5},
        {text: '土曜日', value: 6}
      ]
    }
  }
}
</script>

<style scoped>
.remaining-days-layout {
  grid-template-columns: 80px 1fr;
}
</style>
